/**
 * Community
 *
 * Community is a high-level concept that defines an online community and what it consists of.
 *
 * http://rdfs.org/sioc/ns#Community
 */
var Community = 'http://rdfs.org/sioc/ns#Community';
/**
 * Container
 *
 * An area in which content Items are contained.
 *
 * http://rdfs.org/sioc/ns#Container
 */
var Container = 'http://rdfs.org/sioc/ns#Container';
/**
 * Forum
 *
 * A discussion area on which Posts or entries are made.
 *
 * http://rdfs.org/sioc/ns#Forum
 */
var Forum = 'http://rdfs.org/sioc/ns#Forum';
/**
 * Item
 *
 * An Item is something which can be in a Container.
 *
 * http://rdfs.org/sioc/ns#Item
 */
var Item = 'http://rdfs.org/sioc/ns#Item';
/**
 * Post
 *
 * An article or message that can be posted to a Forum.
 *
 * http://rdfs.org/sioc/ns#Post
 */
var Post = 'http://rdfs.org/sioc/ns#Post';
/**
 * Role
 *
 * A Role is a function of a UserAccount within a scope of a particular Forum, Site, etc.
 *
 * http://rdfs.org/sioc/ns#Role
 */
var Role = 'http://rdfs.org/sioc/ns#Role';
/**
 * Space
 *
 * A Space is a place where data resides, e.g. on a website, desktop, fileshare, etc.
 *
 * http://rdfs.org/sioc/ns#Space
 */
var Space = 'http://rdfs.org/sioc/ns#Space';
/**
 * Site
 *
 * A Site can be the location of an online community or set of communities, with UserAccounts and Usergroups creating Items in a set of Containers. It can be thought of as a web-accessible data Space.
 *
 * http://rdfs.org/sioc/ns#Site
 */
var Site = 'http://rdfs.org/sioc/ns#Site';
/**
 * Thread
 *
 * A container for a series of threaded discussion Posts or Items.
 *
 * http://rdfs.org/sioc/ns#Thread
 */
var Thread = 'http://rdfs.org/sioc/ns#Thread';
/**
 * User Account
 *
 * A user account in an online community site.
 *
 * http://rdfs.org/sioc/ns#UserAccount
 */
var UserAccount = 'http://rdfs.org/sioc/ns#UserAccount';
/**
 * Usergroup
 *
 * A set of UserAccounts whose owners have a common purpose or interest. Can be used for access control purposes.
 *
 * http://rdfs.org/sioc/ns#Usergroup
 */
var Usergroup = 'http://rdfs.org/sioc/ns#Usergroup';
/**
 * about
 *
 * Specifies that this Item is about a particular resource, e.g. a Post describing a book, hotel, etc.
 *
 * http://rdfs.org/sioc/ns#about
 */
var about = 'http://rdfs.org/sioc/ns#about';
/**
 * account of
 *
 * Refers to the foaf:Agent or foaf:Person who owns this sioc:UserAccount.
 *
 * http://rdfs.org/sioc/ns#account_of
 */
var account_of = 'http://rdfs.org/sioc/ns#account_of';
/**
 * addressed to
 *
 * Refers to who (e.g. a UserAccount, e-mail address, etc.) a particular Item is addressed to.
 *
 * http://rdfs.org/sioc/ns#addressed_to
 */
var addressed_to = 'http://rdfs.org/sioc/ns#addressed_to';
/**
 * administrator of
 *
 * A Site that the UserAccount is an administrator of.
 *
 * http://rdfs.org/sioc/ns#administrator_of
 */
var administrator_of = 'http://rdfs.org/sioc/ns#administrator_of';
/**
 * attachment
 *
 * The URI of a file attached to an Item.
 *
 * http://rdfs.org/sioc/ns#attachment
 */
var attachment = 'http://rdfs.org/sioc/ns#attachment';
/**
 * avatar
 *
 * An image or depiction used to represent this UserAccount.
 *
 * http://rdfs.org/sioc/ns#avatar
 */
var avatar = 'http://rdfs.org/sioc/ns#avatar';
/**
 * container of
 *
 * An Item that this Container contains.
 *
 * http://rdfs.org/sioc/ns#container_of
 */
var container_of = 'http://rdfs.org/sioc/ns#container_of';
/**
 * creator of
 *
 * A resource that the UserAccount is a creator of.
 *
 * http://rdfs.org/sioc/ns#creator_of
 */
var creator_of = 'http://rdfs.org/sioc/ns#creator_of';
/**
 * delivered at
 *
 * When this was delivered, in ISO 8601 format.
 *
 * http://rdfs.org/sioc/ns#delivered_at
 */
var delivered_at = 'http://rdfs.org/sioc/ns#delivered_at';
/**
 * discussion of
 *
 * The Item that this discussion is about.
 *
 * http://rdfs.org/sioc/ns#discussion_of
 */
var discussion_of = 'http://rdfs.org/sioc/ns#discussion_of';
/**
 * email
 *
 * An electronic mail address of the UserAccount.
 *
 * http://rdfs.org/sioc/ns#email
 */
var email = 'http://rdfs.org/sioc/ns#email';
/**
 * embeds knowledge
 *
 * This links Items to embedded statements, facts and structured content.
 *
 * http://rdfs.org/sioc/ns#embeds_knowledge
 */
var embeds_knowledge = 'http://rdfs.org/sioc/ns#embeds_knowledge';
/**
 * feed
 *
 * A feed (e.g. RSS, Atom, etc.) pertaining to this resource (e.g. for a Forum, Site, UserAccount, etc.).
 *
 * http://rdfs.org/sioc/ns#feed
 */
var feed = 'http://rdfs.org/sioc/ns#feed';
/**
 * follows
 *
 * Indicates that one UserAccount follows another UserAccount (e.g. for microblog posts or other content item updates).
 *
 * http://rdfs.org/sioc/ns#follows
 */
var follows = 'http://rdfs.org/sioc/ns#follows';
/**
 * function of
 *
 * A UserAccount that has this Role.
 *
 * http://rdfs.org/sioc/ns#function_of
 */
var function_of = 'http://rdfs.org/sioc/ns#function_of';
/**
 * generator
 *
 * A URI for the application used to generate this Item.
 *
 * http://rdfs.org/sioc/ns#generator
 */
var generator = 'http://rdfs.org/sioc/ns#generator';
/**
 * has administrator
 *
 * A UserAccount that is an administrator of this Site.
 *
 * http://rdfs.org/sioc/ns#has_administrator
 */
var has_administrator = 'http://rdfs.org/sioc/ns#has_administrator';
/**
 * has container
 *
 * The Container to which this Item belongs.
 *
 * http://rdfs.org/sioc/ns#has_container
 */
var has_container = 'http://rdfs.org/sioc/ns#has_container';
/**
 * has creator
 *
 * This is the UserAccount that made this resource.
 *
 * http://rdfs.org/sioc/ns#has_creator
 */
var has_creator = 'http://rdfs.org/sioc/ns#has_creator';
/**
 * has discussion
 *
 * A discussion that is related to this Item. The discussion can be anything, for example, a sioc:Forum or sioc:Thread, a sioct:WikiArticle or simply a foaf:Document.
 *
 * http://rdfs.org/sioc/ns#has_discussion
 */
var has_discussion = 'http://rdfs.org/sioc/ns#has_discussion';
/**
 * has function
 *
 * A Role that this UserAccount has.
 *
 * http://rdfs.org/sioc/ns#has_function
 */
var has_function = 'http://rdfs.org/sioc/ns#has_function';
/**
 * has host
 *
 * The Site that hosts this Container.
 *
 * http://rdfs.org/sioc/ns#has_host
 */
var has_host = 'http://rdfs.org/sioc/ns#has_host';
/**
 * has member
 *
 * A UserAccount that is a member of this Usergroup.
 *
 * http://rdfs.org/sioc/ns#has_member
 */
var has_member = 'http://rdfs.org/sioc/ns#has_member';
/**
 * has moderator
 *
 * A UserAccount that is a moderator of this Forum.
 *
 * http://rdfs.org/sioc/ns#has_moderator
 */
var has_moderator = 'http://rdfs.org/sioc/ns#has_moderator';
/**
 * has modifier
 *
 * A UserAccount that modified this resource (e.g. Item, Container, Space).
 *
 * http://rdfs.org/sioc/ns#has_modifier
 */
var has_modifier = 'http://rdfs.org/sioc/ns#has_modifier';
/**
 * has owner
 *
 * A UserAccount that this resource is owned by.
 *
 * http://rdfs.org/sioc/ns#has_owner
 */
var has_owner = 'http://rdfs.org/sioc/ns#has_owner';
/**
 * has parent
 *
 * A Container or Forum that this Container or Forum is a child of.
 *
 * http://rdfs.org/sioc/ns#has_parent
 */
var has_parent = 'http://rdfs.org/sioc/ns#has_parent';
/**
 * has reply
 *
 * Points to an Item or Post that is a reply or response to this Item or Post.
 *
 * http://rdfs.org/sioc/ns#has_reply
 */
var has_reply = 'http://rdfs.org/sioc/ns#has_reply';
/**
 * has scope
 *
 * A resource that this Role applies to.
 *
 * http://rdfs.org/sioc/ns#has_scope
 */
var has_scope = 'http://rdfs.org/sioc/ns#has_scope';
/**
 * has space
 *
 * A data Space which this resource is a part of.
 *
 * http://rdfs.org/sioc/ns#has_space
 */
var has_space = 'http://rdfs.org/sioc/ns#has_space';
/**
 * has subscriber
 *
 * A UserAccount that is subscribed to this Container.
 *
 * http://rdfs.org/sioc/ns#has_subscriber
 */
var has_subscriber = 'http://rdfs.org/sioc/ns#has_subscriber';
/**
 * has usergroup
 *
 * Points to a Usergroup that has certain access to this Space.
 *
 * http://rdfs.org/sioc/ns#has_usergroup
 */
var has_usergroup = 'http://rdfs.org/sioc/ns#has_usergroup';
/**
 * host of
 *
 * A Container that is hosted on this Site.
 *
 * http://rdfs.org/sioc/ns#host_of
 */
var host_of = 'http://rdfs.org/sioc/ns#host_of';
/**
 * latest version
 *
 * Links to the latest revision of this Item or Post.
 *
 * http://rdfs.org/sioc/ns#latest_version
 */
var latest_version = 'http://rdfs.org/sioc/ns#latest_version';
/**
 * likes
 *
 * Used to indicate some form of endorsement by a UserAccount or Agent of an Item, Container, Space, UserAccount, etc.
 *
 * http://rdfs.org/sioc/ns#likes
 */
var likes = 'http://rdfs.org/sioc/ns#likes';
/**
 * link
 *
 * A URI of a document which contains this SIOC object.
 *
 * http://rdfs.org/sioc/ns#link
 */
var link = 'http://rdfs.org/sioc/ns#link';
/**
 * links to
 *
 * Links extracted from hyperlinks within a SIOC concept, e.g. Post or Site.
 *
 * http://rdfs.org/sioc/ns#links_to
 */
var links_to = 'http://rdfs.org/sioc/ns#links_to';
/**
 * member of
 *
 * A Usergroup that this UserAccount is a member of.
 *
 * http://rdfs.org/sioc/ns#member_of
 */
var member_of = 'http://rdfs.org/sioc/ns#member_of';
/**
 * mentions
 *
 * Refers to a UserAccount that a particular Item mentions.
 *
 * http://rdfs.org/sioc/ns#mentions
 */
var mentions = 'http://rdfs.org/sioc/ns#mentions';
/**
 * moderator of
 *
 * A Forum that a UserAccount is a moderator of.
 *
 * http://rdfs.org/sioc/ns#moderator_of
 */
var moderator_of = 'http://rdfs.org/sioc/ns#moderator_of';
/**
 * modifier of
 *
 * A resource that this UserAccount has modified.
 *
 * http://rdfs.org/sioc/ns#modifier_of
 */
var modifier_of = 'http://rdfs.org/sioc/ns#modifier_of';
/**
 * next by date
 *
 * Next Item or Post in a given Container sorted by date.
 *
 * http://rdfs.org/sioc/ns#next_by_date
 */
var next_by_date = 'http://rdfs.org/sioc/ns#next_by_date';
/**
 * next version
 *
 * Links to the next revision of this Item or Post.
 *
 * http://rdfs.org/sioc/ns#next_version
 */
var next_version = 'http://rdfs.org/sioc/ns#next_version';
/**
 * owner of
 *
 * A resource owned by a particular UserAccount, for example, a weblog or image gallery.
 *
 * http://rdfs.org/sioc/ns#owner_of
 */
var owner_of = 'http://rdfs.org/sioc/ns#owner_of';
/**
 * parent of
 *
 * A child Container or Forum that this Container or Forum is a parent of.
 *
 * http://rdfs.org/sioc/ns#parent_of
 */
var parent_of = 'http://rdfs.org/sioc/ns#parent_of';
/**
 * previous by date
 *
 * Previous Item or Post in a given Container sorted by date.
 *
 * http://rdfs.org/sioc/ns#previous_by_date
 */
var previous_by_date = 'http://rdfs.org/sioc/ns#previous_by_date';
/**
 * previous version
 *
 * Links to the previous revision of this Item or Post.
 *
 * http://rdfs.org/sioc/ns#previous_version
 */
var previous_version = 'http://rdfs.org/sioc/ns#previous_version';
/**
 * read at
 *
 * When this was read, in ISO 8601 format.
 *
 * http://rdfs.org/sioc/ns#read_at
 */
var read_at = 'http://rdfs.org/sioc/ns#read_at';
/**
 * related to
 *
 * Related resources for this resource, e.g. for Posts, perhaps determined implicitly from topics or references.
 *
 * http://rdfs.org/sioc/ns#related_to
 */
var related_to = 'http://rdfs.org/sioc/ns#related_to';
/**
 * reply of
 *
 * Links to an Item or Post which this Item or Post is a reply to.
 *
 * http://rdfs.org/sioc/ns#reply_of
 */
var reply_of = 'http://rdfs.org/sioc/ns#reply_of';
/**
 * respond to
 *
 * For the reply-to address set in email messages, IMs, etc. The property name was chosen to avoid confusion with has_reply/reply_of (the reply graph).
 *
 * http://rdfs.org/sioc/ns#respond_to
 */
var respond_to = 'http://rdfs.org/sioc/ns#respond_to';
/**
 * scope of
 *
 * A Role that has a scope of this resource.
 *
 * http://rdfs.org/sioc/ns#scope_of
 */
var scope_of = 'http://rdfs.org/sioc/ns#scope_of';
/**
 * shared by
 *
 * For shared Items where there is a certain creator_of and an intermediary who shares or forwards it (e.g. as a sibling Item).
 *
 * http://rdfs.org/sioc/ns#shared_by
 */
var shared_by = 'http://rdfs.org/sioc/ns#shared_by';
/**
 * space of
 *
 * A resource which belongs to this data Space.
 *
 * http://rdfs.org/sioc/ns#space_of
 */
var space_of = 'http://rdfs.org/sioc/ns#space_of';
/**
 * subscriber of
 *
 * A Container that a UserAccount is subscribed to.
 *
 * http://rdfs.org/sioc/ns#subscriber_of
 */
var subscriber_of = 'http://rdfs.org/sioc/ns#subscriber_of';
/**
 * topic
 *
 * A topic of interest, linking to the appropriate URI, e.g. in the Open Directory Project or of a SKOS category.
 *
 * http://rdfs.org/sioc/ns#topic
 */
var topic = 'http://rdfs.org/sioc/ns#topic';
/**
 * usergroup of
 *
 * A Space that the Usergroup has access to.
 *
 * http://rdfs.org/sioc/ns#usergroup_of
 */
var usergroup_of = 'http://rdfs.org/sioc/ns#usergroup_of';
/**
 * group of
 *
 *
 *
 * http://rdfs.org/sioc/ns#group_of
 */
var group_of = 'http://rdfs.org/sioc/ns#group_of';
/**
 * has group
 *
 *
 *
 * http://rdfs.org/sioc/ns#has_group
 */
var has_group = 'http://rdfs.org/sioc/ns#has_group';
/**
 * has part
 *
 * An resource that is a part of this subject.
 *
 * http://rdfs.org/sioc/ns#has_part
 */
var has_part = 'http://rdfs.org/sioc/ns#has_part';
/**
 * part of
 *
 * A resource that the subject is a part of.
 *
 * http://rdfs.org/sioc/ns#part_of
 */
var part_of = 'http://rdfs.org/sioc/ns#part_of';
/**
 * reference
 *
 * Links either created explicitly or extracted implicitly on the HTML level from the Post.
 *
 * http://rdfs.org/sioc/ns#reference
 */
var reference = 'http://rdfs.org/sioc/ns#reference';
/**
 * content
 *
 * The content of the Item in plain text format.
 *
 * http://rdfs.org/sioc/ns#content
 */
var content = 'http://rdfs.org/sioc/ns#content';
/**
 * email sha1
 *
 * An electronic mail address of the UserAccount, encoded using SHA1.
 *
 * http://rdfs.org/sioc/ns#email_sha1
 */
var email_sha1 = 'http://rdfs.org/sioc/ns#email_sha1';
/**
 * id
 *
 * An identifier of a SIOC concept instance. For example, a user ID. Must be unique for instances of each type of SIOC concept within the same site.
 *
 * http://rdfs.org/sioc/ns#id
 */
var id = 'http://rdfs.org/sioc/ns#id';
/**
 * ip address
 *
 * The IP address used when creating this Item, UserAccount, etc. This can be associated with a creator. Some wiki articles list the IP addresses for the creator or modifiers when the usernames are absent.
 *
 * http://rdfs.org/sioc/ns#ip_address
 */
var ip_address = 'http://rdfs.org/sioc/ns#ip_address';
/**
 * last activity date
 *
 * The date and time of the last activity associated with a SIOC concept instance, and expressed in ISO 8601 format. This could be due to a reply Post or Comment, a modification to an Item, etc.
 *
 * http://rdfs.org/sioc/ns#last_activity_date
 */
var last_activity_date = 'http://rdfs.org/sioc/ns#last_activity_date';
/**
 * last item date
 *
 * The date and time of the last Post (or Item) in a Forum (or a Container), in ISO 8601 format.
 *
 * http://rdfs.org/sioc/ns#last_item_date
 */
var last_item_date = 'http://rdfs.org/sioc/ns#last_item_date';
/**
 * last reply date
 *
 * The date and time of the last reply Post or Comment, which could be associated with a starter Item or Post or with a Thread, and expressed in ISO 8601 format.
 *
 * http://rdfs.org/sioc/ns#last_reply_date
 */
var last_reply_date = 'http://rdfs.org/sioc/ns#last_reply_date';
/**
 * name
 *
 * The name of a SIOC concept instance, e.g. a username for a UserAccount, group name for a Usergroup, etc.
 *
 * http://rdfs.org/sioc/ns#name
 */
var name = 'http://rdfs.org/sioc/ns#name';
/**
 * note
 *
 * A note associated with this resource, for example, if it has been edited by a UserAccount.
 *
 * http://rdfs.org/sioc/ns#note
 */
var note = 'http://rdfs.org/sioc/ns#note';
/**
 * num authors
 *
 * The number of unique authors (UserAccounts and unregistered posters) who have contributed to this Item, Thread, Post, etc.
 *
 * http://rdfs.org/sioc/ns#num_authors
 */
var num_authors = 'http://rdfs.org/sioc/ns#num_authors';
/**
 * num items
 *
 * The number of Posts (or Items) in a Forum (or a Container).
 *
 * http://rdfs.org/sioc/ns#num_items
 */
var num_items = 'http://rdfs.org/sioc/ns#num_items';
/**
 * num replies
 *
 * The number of replies that this Item, Thread, Post, etc. has. Useful for when the reply structure is absent.
 *
 * http://rdfs.org/sioc/ns#num_replies
 */
var num_replies = 'http://rdfs.org/sioc/ns#num_replies';
/**
 * num threads
 *
 * The number of Threads (AKA discussion topics) in a Forum.
 *
 * http://rdfs.org/sioc/ns#num_threads
 */
var num_threads = 'http://rdfs.org/sioc/ns#num_threads';
/**
 * num views
 *
 * The number of times this Item, Thread, UserAccount profile, etc. has been viewed.
 *
 * http://rdfs.org/sioc/ns#num_views
 */
var num_views = 'http://rdfs.org/sioc/ns#num_views';
/**
 * title
 *
 * This is the title (subject line) of the Post. Note that for a Post within a threaded discussion that has no parents, it would detail the topic thread.
 *
 * http://rdfs.org/sioc/ns#title
 */
var title = 'http://rdfs.org/sioc/ns#title';
/**
 * content encoded
 *
 * The encoded content of the Post, contained in CDATA areas.
 *
 * http://rdfs.org/sioc/ns#content_encoded
 */
var content_encoded = 'http://rdfs.org/sioc/ns#content_encoded';
/**
 * created at
 *
 * When this was created, in ISO 8601 format.
 *
 * http://rdfs.org/sioc/ns#created_at
 */
var created_at = 'http://rdfs.org/sioc/ns#created_at';
/**
 * description
 *
 * The content of the Post.
 *
 * http://rdfs.org/sioc/ns#description
 */
var description = 'http://rdfs.org/sioc/ns#description';
/**
 * first name
 *
 * First (real) name of this User. Synonyms include given name or christian name.
 *
 * http://rdfs.org/sioc/ns#first_name
 */
var first_name = 'http://rdfs.org/sioc/ns#first_name';
/**
 * last name
 *
 * Last (real) name of this user. Synonyms include surname or family name.
 *
 * http://rdfs.org/sioc/ns#last_name
 */
var last_name = 'http://rdfs.org/sioc/ns#last_name';
/**
 * modified at
 *
 * When this was modified, in ISO 8601 format.
 *
 * http://rdfs.org/sioc/ns#modified_at
 */
var modified_at = 'http://rdfs.org/sioc/ns#modified_at';
/**
 * subject
 *
 * Keyword(s) describing subject of the Post.
 *
 * http://rdfs.org/sioc/ns#subject
 */
var subject = 'http://rdfs.org/sioc/ns#subject';

var siocImport = /*#__PURE__*/Object.freeze({
	Community: Community,
	Container: Container,
	Forum: Forum,
	Item: Item,
	Post: Post,
	Role: Role,
	Space: Space,
	Site: Site,
	Thread: Thread,
	UserAccount: UserAccount,
	Usergroup: Usergroup,
	about: about,
	account_of: account_of,
	addressed_to: addressed_to,
	administrator_of: administrator_of,
	attachment: attachment,
	avatar: avatar,
	container_of: container_of,
	creator_of: creator_of,
	delivered_at: delivered_at,
	discussion_of: discussion_of,
	email: email,
	embeds_knowledge: embeds_knowledge,
	feed: feed,
	follows: follows,
	function_of: function_of,
	generator: generator,
	has_administrator: has_administrator,
	has_container: has_container,
	has_creator: has_creator,
	has_discussion: has_discussion,
	has_function: has_function,
	has_host: has_host,
	has_member: has_member,
	has_moderator: has_moderator,
	has_modifier: has_modifier,
	has_owner: has_owner,
	has_parent: has_parent,
	has_reply: has_reply,
	has_scope: has_scope,
	has_space: has_space,
	has_subscriber: has_subscriber,
	has_usergroup: has_usergroup,
	host_of: host_of,
	latest_version: latest_version,
	likes: likes,
	link: link,
	links_to: links_to,
	member_of: member_of,
	mentions: mentions,
	moderator_of: moderator_of,
	modifier_of: modifier_of,
	next_by_date: next_by_date,
	next_version: next_version,
	owner_of: owner_of,
	parent_of: parent_of,
	previous_by_date: previous_by_date,
	previous_version: previous_version,
	read_at: read_at,
	related_to: related_to,
	reply_of: reply_of,
	respond_to: respond_to,
	scope_of: scope_of,
	shared_by: shared_by,
	space_of: space_of,
	subscriber_of: subscriber_of,
	topic: topic,
	usergroup_of: usergroup_of,
	group_of: group_of,
	has_group: has_group,
	has_part: has_part,
	part_of: part_of,
	reference: reference,
	content: content,
	email_sha1: email_sha1,
	id: id,
	ip_address: ip_address,
	last_activity_date: last_activity_date,
	last_item_date: last_item_date,
	last_reply_date: last_reply_date,
	name: name,
	note: note,
	num_authors: num_authors,
	num_items: num_items,
	num_replies: num_replies,
	num_threads: num_threads,
	num_views: num_views,
	title: title,
	content_encoded: content_encoded,
	created_at: created_at,
	description: description,
	first_name: first_name,
	last_name: last_name,
	modified_at: modified_at,
	subject: subject
});

export { next_version as $, has_moderator as A, has_modifier as B, Community as C, has_owner as D, has_parent as E, Forum as F, has_reply as G, has_scope as H, Item as I, has_space as J, has_subscriber as K, has_usergroup as L, host_of as M, latest_version as N, likes as O, Post as P, link as Q, Role as R, Space as S, Thread as T, UserAccount as U, links_to as V, member_of as W, mentions as X, moderator_of as Y, modifier_of as Z, next_by_date as _, Container as a, owner_of as a0, parent_of as a1, previous_by_date as a2, previous_version as a3, read_at as a4, related_to as a5, reply_of as a6, respond_to as a7, scope_of as a8, shared_by as a9, description as aA, first_name as aB, last_name as aC, modified_at as aD, subject as aE, siocImport as aF, space_of as aa, subscriber_of as ab, topic as ac, usergroup_of as ad, group_of as ae, has_group as af, has_part as ag, part_of as ah, reference as ai, content as aj, email_sha1 as ak, id as al, ip_address as am, last_activity_date as an, last_item_date as ao, last_reply_date as ap, name as aq, note as ar, num_authors as as, num_items as at, num_replies as au, num_threads as av, num_views as aw, title as ax, content_encoded as ay, created_at as az, Site as b, Usergroup as c, about as d, account_of as e, addressed_to as f, administrator_of as g, attachment as h, avatar as i, container_of as j, creator_of as k, delivered_at as l, discussion_of as m, email as n, embeds_knowledge as o, feed as p, follows as q, function_of as r, generator as s, has_administrator as t, has_container as u, has_creator as v, has_discussion as w, has_function as x, has_host as y, has_member as z };
